import store from '../../../redux/store.js'
import { mixpanel1, mixpanel2 } from './client.js';
import { isDevelopment } from '../../../configurations/env_config';
import Bugsnag from '@bugsnag/js';

// Analytics must never break product flow
const safe = (fn) => {
    try { fn(); } catch (e) { Bugsnag.notify(e); }
};

const currentContext = () => ({
    user: store.getState().current_user.user,
    team: store.getState().current_team.team,
});

const teamProps = (team) => ({ team_id: team.id, team_name: team.name, team_premium: !!team.premium });

const shouldTrackBase = (user, team) => {
    if (isDevelopment) return false;
    if (!user?.id || !team?.id) return false;
    if (team.outbound_enabled) return false;
    return !!(team.verified || team.premium);
};

const shouldTrack1 = (user, team) => {
    if (!shouldTrackBase(user, team)) return false;
    if (team.role === 'passive' || !team.approved_at) return false;
    return !(user.is_super_member || user.email?.split('@')[1]?.toLowerCase() === 'almaconnect.com');
};

const shouldTrack2 = (user, team) => shouldTrackBase(user, team);

const createTracker = (client, allowed) => ({
    init: (user, team) => safe(() => {
        if (!allowed(user, team)) return;
        client.identify(user.id);
    }),
    track: (eventName = "No Event Name Assigned", props = {}) => safe(() => {
        const { user, team } = currentContext();
        if (!allowed(user, team)) return;
        client.track(eventName, {...props, ...teamProps(team)});
    }),
    trackPageView: (props = {}) => safe(() => {
        const { user, team } = currentContext();
        if (!allowed(user, team)) return;
        client.track_pageview({...props, ...teamProps(team)});
    }),
    startSessionRecording: () => safe(() => {
        const { user, team } = currentContext();
        if (!allowed(user, team)) return;
        client.start_session_recording();
    }),
    reset: () => safe(() => client.reset()),
});

export const Tracker = createTracker(mixpanel1, shouldTrack1);
export const Tracker2 = createTracker(mixpanel2, shouldTrack2);

// Page context for events fired from shared components (Post cards, popups) that render on several pages.
export const getTrackingPage = (path = window.location.pathname) => {
    path = path.replace(/\/+$/, '') || '/'; // normalize trailing slash: '/prospects/archived/' -> '/prospects/archived'
    if (path === '/' || path.startsWith('/feed')) return 'newsfeed';
    if (path.startsWith('/prospects/') && path !== '/prospects/archived') return 'prospect_profile';
    if (path.startsWith('/prospects')) return 'prospects';
    if (path.startsWith('/prospect_articles')) return 'prospect_articles';
    if (path.startsWith('/post/')) return 'single_post';
    if (path.startsWith('/news_source/')) return 'news_source_feed';
    if (path.startsWith('/saved_searches')) return 'saved_searches';
    if (path.startsWith('/search')) return 'search_page';
    if (path.startsWith('/directory')) return 'directory';
    return path;
};

